"use client";

import * as React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Database, LayoutDashboard, Menu, ScrollText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { NAV_ITEMS, APP_TITLE } from "@/lib/constants";

const ICONS = {
  "/dashboard": LayoutDashboard,
  "/logs": ScrollText,
} as const;

export function MobileNavigation() {
  const pathname = usePathname();
  const [open, setOpen] = React.useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden" aria-label="Open navigation menu">
          <Menu className="size-5" aria-hidden="true" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-64 p-0">
        <SheetHeader className="border-b px-4 py-3">
          <SheetTitle className="flex items-center gap-2 text-sm">
            <Database className="size-5 text-primary" aria-hidden="true" />
            {APP_TITLE}
          </SheetTitle>
        </SheetHeader>
        <nav className="space-y-1 p-2">
          {NAV_ITEMS.map((item) => {
            const Icon = ICONS[item.href];
            const isActive = pathname.startsWith(item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                aria-current={isActive ? "page" : undefined}
                className={cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium",
                  isActive ? "bg-accent text-accent-foreground" : "text-foreground/80 hover:bg-accent",
                )}
              >
                <Icon className="size-4" aria-hidden="true" />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </SheetContent>
    </Sheet>
  );
}
